import { adNotam } from '../../init';

adNotam.website.becomeadealer = {
  init: function () {
    if ($('#formWithSummary')) {
      adNotam.website.formWithSummary.init();
    }
  }
};
